/* Collection 1.4.1: layout preference and second product photograph only. */
(()=>{
'use strict';
const root=document.querySelector('[data-iu-size-test]');if(!root)return;
const selector=root.querySelector('[data-st-columns]'),small=matchMedia('(max-width:749px)');
const preference={desktop:4,mobile:2};
for(const mode of ['desktop','mobile']){try{const n=Number(localStorage.getItem('iu-catalog-columns-'+mode));if((mode==='mobile'?[1,2]:[2,3,4,5]).includes(n))preference[mode]=n;}catch{}}
function updateImageSizes(){
 const grid=root.querySelector('[data-st-grid]'),columns=Number(root.style.getPropertyValue('--iu-card-columns'))||(small.matches?2:4);
 const width=grid.getBoundingClientRect().width||root.querySelector('.iu-st-results').getBoundingClientRect().width||document.documentElement.clientWidth;
 const gap=parseFloat(getComputedStyle(grid).columnGap)||0,sizes=Math.max(1,Math.ceil((width-gap*(columns-1))/columns))+'px';
 root.querySelectorAll('.iu-st-image img').forEach(img=>{if(img.sizes!==sizes)img.sizes=sizes;});
}
let resizeFrame;
addEventListener('resize',()=>{cancelAnimationFrame(resizeFrame);resizeFrame=requestAnimationFrame(updateImageSizes);},{passive:true});
function columns(){const mode=small.matches?'mobile':'desktop',values=small.matches?[1,2]:[2,3,4,5];selector.innerHTML=values.map(v=>'<option value="'+v+'">'+v+'</option>').join('');selector.value=String(preference[mode]);root.style.setProperty('--iu-card-columns',selector.value);updateImageSizes();}
columns();small.addEventListener('change',columns);selector.addEventListener('change',()=>{const mode=small.matches?'mobile':'desktop',n=Number(selector.value);if(!(small.matches?[1,2]:[2,3,4,5]).includes(n))return;preference[mode]=n;root.style.setProperty('--iu-card-columns',String(n));updateImageSizes();try{localStorage.setItem('iu-catalog-columns-'+mode,String(n));}catch{}});
function indicatePhotos(link){
 if(link.querySelector('.iu-st-photo-dots'))return;
 const dots=document.createElement('span');dots.className='iu-st-photo-dots';dots.setAttribute('aria-hidden','true');
 dots.append(document.createElement('i'),document.createElement('i'));link.append(dots);
}
function load(link){const img=link.querySelector('[data-secondary-src]');if(!img||img.getAttribute('src'))return;
 img.onload=()=>{if(img.naturalWidth>0){link.classList.add('iu-st-second-ready');indicatePhotos(link);}};
 img.onerror=()=>{link.classList.remove('iu-st-has-second','iu-st-photo-selected','iu-st-second-ready');link.dataset.secondaryFailed='true';link.removeAttribute('aria-label');link.querySelector('.iu-st-photo-dots')?.remove();img.remove();};
 if(img.dataset.secondarySrcset)img.srcset=img.dataset.secondarySrcset;
 img.src=img.dataset.secondarySrc;
}
let observer;
function mount(){updateImageSizes();observer?.disconnect();if('IntersectionObserver'in window){observer=new IntersectionObserver(entries=>{for(const e of entries)if(e.isIntersecting){load(e.target);observer.unobserve(e.target);}},{rootMargin:'160px'});root.querySelectorAll('.iu-st-has-second').forEach(link=>observer.observe(link));}}
root.addEventListener('iu:cards-rendered',mount);mount();
root.addEventListener('pointerover',e=>{const link=e.target.closest('.iu-st-has-second');if(link)load(link);});
root.addEventListener('focusin',e=>{const link=e.target.closest('.iu-st-has-second');if(link)load(link);});
// 4.1.3: touch swipes preview photos; ordinary taps remain native product links.
let gesture=null,swipeClick=null;
document.addEventListener('pointerdown',e=>{
 swipeClick=null;
 if(e.pointerType==='touch'&&!e.isPrimary)gesture=null;
},{capture:true,passive:true});
root.addEventListener('pointerdown',e=>{
 if(e.pointerType!=='touch'||!e.isPrimary){gesture=null;return;}
 const link=e.target.closest('.iu-st-has-second');
 if(!link||!link.classList.contains('iu-st-second-ready'))return;
 gesture={link,id:e.pointerId,x:e.clientX,y:e.clientY,axis:null};
},{passive:true});
root.addEventListener('pointermove',e=>{
 if(!gesture||e.pointerId!==gesture.id||gesture.axis)return;
 const x=Math.abs(e.clientX-gesture.x),y=Math.abs(e.clientY-gesture.y);
 if(Math.max(x,y)<12)return;
 // Lock vertically unless the initial movement clearly intends a horizontal swipe.
 gesture.axis=x>y*1.3?'x':'y';
},{passive:true});
root.addEventListener('pointerup',e=>{
 const current=gesture;if(!current||e.pointerId!==current.id)return;gesture=null;
 const x=e.clientX-current.x,y=e.clientY-current.y;
 if(current.axis==='y'||Math.abs(x)<32||Math.abs(x)<=Math.abs(y)*1.3)return;
 if(!current.link.isConnected||!current.link.classList.contains('iu-st-second-ready'))return;
 current.link.classList.toggle('iu-st-photo-selected',x<0);
 // A browser may emit click after a swipe. Consume only that gesture's click.
 swipeClick={link:current.link,id:current.id,until:Date.now()+700};
},{passive:true});
root.addEventListener('pointercancel',e=>{if(gesture?.id===e.pointerId)gesture=null;},{passive:true});
root.addEventListener('lostpointercapture',e=>{if(gesture?.id===e.pointerId)gesture=null;},{passive:true});
document.addEventListener('visibilitychange',()=>{if(document.hidden){gesture=null;swipeClick=null;}});
root.addEventListener('click',e=>{
 if(!swipeClick||e.detail===0||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
 if(Date.now()>swipeClick.until){swipeClick=null;return;}
 if(e.target.closest('.iu-st-image')!==swipeClick.link)return;
 if(e.pointerId>0&&e.pointerId!==swipeClick.id)return;
 swipeClick=null;e.preventDefault();e.stopPropagation();
},true);
root.addEventListener('iu:cards-rendered',()=>{gesture=null;swipeClick=null;});

})();
